import { Megaphone } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Section, LockedRow } from "@/components/plan/common";

export default function GoogleAdsSection({ ads, isFree }) {
  if (!ads) return null;
  const campaigns = ads.campaign_structure || [];
  const adCopy = ads.ad_copy || [];
  const shownCampaigns = campaigns.slice(0, isFree ? 1 : undefined);
  const shownCopy = adCopy.slice(0, isFree ? 2 : undefined);

  return (
    <Section icon={Megaphone} title="Google Ads campaigns">
      <div className="space-y-4">
        {shownCampaigns.map((c, i) => (
          <div key={`camp-${i}-${c.campaign_name || ""}`} className="bg-white border border-zinc-200 rounded-2xl p-6">
            <div className="flex flex-wrap items-center gap-2 justify-between">
              <h4 className="font-display font-black text-xl">{c.campaign_name}</h4>
              <div className="flex gap-2 flex-wrap">
                <Badge variant="secondary">{c.campaign_type}</Badge>
                <Badge>₹{c.daily_budget_inr}/day</Badge>
              </div>
            </div>
            <p className="text-sm text-zinc-500 mt-1">Locations: {c.target_locations}</p>
            <div className="mt-4 space-y-3">
              {c.ad_groups?.map((ag, j) => (
                <div key={`adg-${j}-${(ag.name || "").slice(0, 20)}`} className="border border-zinc-100 rounded-lg p-3 bg-zinc-50">
                  <div className="flex items-center justify-between">
                    <div className="font-medium text-sm">{ag.name}</div>
                    <Badge variant="outline" className="text-[10px]">{ag.match_type}</Badge>
                  </div>
                  <div className="flex flex-wrap gap-1 mt-2">
                    {ag.keywords?.map((k, ki) => (
                      <span key={`agkw-${ki}-${k}`} className="text-[11px] bg-white border border-zinc-200 px-2 py-0.5 rounded-full">{k}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
        {isFree && campaigns.length > 1 && (
          <LockedRow message={`${campaigns.length - 1} more campaign(s) available on paid tier`} />
        )}
      </div>

      {shownCopy.length > 0 && (
        <div className="mt-6">
          <h4 className="font-display font-black text-xl mb-3">Ad copy variations</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {shownCopy.map((a, i) => (
              <div key={`adcopy-${i}-${a.headline_1 || ""}`} className="bg-white border border-zinc-200 rounded-2xl p-5">
                <div className="text-[10px] uppercase tracking-widest text-zinc-400">Ad #{i + 1}</div>
                <div className="font-medium text-indigo-700 mt-1">{a.headline_1} · {a.headline_2} · {a.headline_3}</div>
                <p className="text-sm text-zinc-600 mt-2">{a.description_1}</p>
                <p className="text-sm text-zinc-600">{a.description_2}</p>
              </div>
            ))}
          </div>
          {isFree && adCopy.length > 2 && (
            <div className="mt-3"><LockedRow message={`${adCopy.length - 2} more ad copy variations locked`} /></div>
          )}
        </div>
      )}
    </Section>
  );
}
